const changeButtonColor = () => {
    const element = document.querySelector('.social-networks')

    if( element !== null ) {
        const elementTop = element.offsetTop + window.scrollY
    
        Array.from(document.querySelectorAll('.home-banner, .articles-page, .page-banner, #search-page, .fl-builder-content > .fl-row, footer')).forEach(section => {
            let sectionTop = section.offsetTop
            let sectionBottom = section.offsetTop + section.offsetHeight
            
            if (elementTop >= sectionTop && elementTop <= sectionBottom) {
                if( 
                    window.getComputedStyle(section).backgroundColor !== "rgba(0, 0, 0, 0)" || 
                    window.getComputedStyle(section).backgroundImage !== "none" || 
                    (section.classList.contains('fl-row-bg-color') && !section.classList.contains('bg-darker')) || 
                    section.classList.contains('fl-row-bg-parallax') || 
                    section.classList.contains('page-banner') || 
                    section.classList.contains('fl-row-bg-photo')
                ) {
                    element.style.setProperty('--social-color', 'white')
                } else {
                    element.style.removeProperty('--social-color')
                }
            }
        })
    }
}

changeButtonColor()
window.addEventListener('scroll', changeButtonColor)